export default "__VITE_ASSET__le9u7$aL__"